/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { TimeLineGroupInfoResponse } from "./TimeLineGroupInfoResponse";

export type TimeLineGroupInfoResponseApiRespoonse = {
  data?: TimeLineGroupInfoResponse;
  status?: TimeLineGroupInfoResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace TimeLineGroupInfoResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
